import { createSelector } from 'reselect'
import { AppGlobalState, Progress } from '../../types'
import { DistributorOrder } from 'types/distributorOrder'
import { EntityMetadata } from 'modules/domain/types'

const dict = (state: AppGlobalState) => state.distributorOrder.items
const ids = (state: AppGlobalState) => state.distributorOrder.ids
const item = (state: AppGlobalState, id: string): DistributorOrder | undefined => state.distributorOrder.items[id]
const meta = (state: AppGlobalState, id: string): EntityMetadata<DistributorOrder> =>
  state.distributorOrder.meta[id] || {
    fetchError: null,
    fetchProgress: Progress.IDLE,
    id,
    removeError: null,
    removeProgress: Progress.IDLE,
    updateError: null,
    updateProgress: Progress.IDLE,
  }
const itemFetchProgress = (state: AppGlobalState) => state.distributorOrder.itemFetchProgress
const listFetchProgress = (state: AppGlobalState) => state.distributorOrder.listFetchProgress
const listFetchError = (state: AppGlobalState) => state.distributorOrder.listFetchError
const listFetchNextProgress = (state: AppGlobalState) => state.distributorOrder.listFetchNextProgress
const listFetchNextError = (state: AppGlobalState) => state.distributorOrder.listFetchNextError
const list = createSelector(dict, ids, listFetchProgress, (dict, ids, progress) => {
  if (progress === Progress.WORK) {
    return []
  }
  const result: DistributorOrder[] = []
  for (const id of ids) {
    result.push(dict[id])
  }
  return result
})

const filter = (state: AppGlobalState) => state.distributorOrder.filter
const sorting = (state: AppGlobalState) => state.distributorOrder.sorting
const page = (state: AppGlobalState) => state.distributorOrder.page
const total = (state: AppGlobalState) => state.distributorOrder.total
const updateProgress = (state: AppGlobalState) => state.distributorOrder.updateProgress
const removeProgress = (state: AppGlobalState) => state.distributorOrder.removeProgress
const addProgress = (state: AppGlobalState) => state.distributorOrder.addProgress
const hasNext = (state: AppGlobalState) => state.distributorOrder.total > state.distributorOrder.ids.length
const pageSize = (state: AppGlobalState) => state.distributorOrder.pageSize
const pages = (state: AppGlobalState) => Math.ceil(state.distributorOrder.total / state.distributorOrder.pageSize)
const newOrdersCount = (state: AppGlobalState) => state.distributorOrder.newOrdersCount
const newOrdersCountProgress = (state: AppGlobalState) => state.distributorOrder.newOrdersCountProgress

const DistributorOrderSelectors = {
  filter,
  sorting,
  page,
  total,
  updateProgress,
  removeProgress,
  addProgress,
  item,
  meta,
  itemFetchProgress,
  listFetchProgress,
  listFetchError,
  list,
  dict,
  ids,
  hasNext,
  pageSize,
  listFetchNextProgress,
  listFetchNextError,
  pages,
  newOrdersCount,
  newOrdersCountProgress,
}

export default DistributorOrderSelectors
